import {gsap} from "gsap";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import TweenLite, {Power2, TweenMax} from "gsap";

gsap.registerPlugin(ScrollToPlugin);

export default () => {

    const golfPage = document.querySelector(".resort-template-template-golf-club");
    //Anchor links
    const anchors = document.querySelectorAll('.page-menu__link');
    if (!golfPage) {
        for (let anchor of anchors) {
            anchor.addEventListener('click', function (e) {
                e.preventDefault();

                let siteHeader = document.querySelector('.site_header');
                let siteHeaderOffset = siteHeader.offsetHeight / 2 + 100;
                let blockID = anchor.getAttribute('href');

                gsap.to(window, {
                    duration: 1,
                    scrollTo: {
                        y: blockID,
                        offsetY: siteHeaderOffset
                    },


                });
            })
        }
    } else {
        for (let anchor of anchors) {
            anchor.addEventListener('click', function (e) {
                e.preventDefault();

                let siteHeader = document.querySelector('.site_header');
                let siteHeaderOffset = siteHeader.offsetHeight / 2 + 100;
                let blockID = anchor.getAttribute('href');

                gsap.to(window, {
                    duration: 0,
                    scrollTo: {
                        y: blockID,
                        offsetY: siteHeaderOffset
                    },


                });
            })
        }
        const anchorsWrapper = document.querySelector(".page-menu__menu");
        const anchorLink = anchorsWrapper.querySelector("a[href='#membership']");
        const accorderonWrapper = document.querySelector(".membership_accordion");
        const accordeonTitle = accorderonWrapper.querySelector(".title");
        const accordeonBlock = accorderonWrapper.querySelector(".accordion_content");
        const accordeon = accorderonWrapper.querySelector(".content_table");
        if (anchorLink) {
            anchorLink.addEventListener("click", () => {
                accordeonTitle.classList.toggle("active");
                accordeonBlock.setAttribute('style', 'display:block;');
                accordeon.setAttribute('style', 'visibility: visible;  -webkit-transform: translateY(0) scale(1); opacity: 1;transform: translateY(0) scale(1); opacity: 1;-webkit-transition: -webkit-transform 1.2s ease-in-out 0.2s, opacity 1.2s ease-in-out 0.2s; transition: transform 1.2s ease-in-out 0.2s, opacity 1.2s ease-in-out 0.2s; ');
            })
        }
    }
    // Accordion open anchor click (see main.js:1131)


    // end accordeon open
    //Sticky navigation
    let window_width = window.innerWidth;
    let cptNavigationContainer = document.querySelector('.page-menu__wrapper');
    if (cptNavigationContainer) {
        //Navigation
        let body = document.body;
        let cptNavigationPosition = document.querySelector('.menu__wrapper-position');
        let navigationContainer = cptNavigationContainer.querySelector('.page-menu__container');
        let navigationContainerHeight = navigationContainer.offsetHeight;
        let navigation = cptNavigationContainer.querySelector('.page-menu__menu');
        let navigationLinks = document.querySelectorAll(".page-menu__link");
        let scrollSection = document.querySelectorAll("div, section");
        cptNavigationContainer.style.height = navigationContainerHeight + 'px';

        // let viewportOffset = cptNavigationContainer.getBoundingClientRect();
        // let top = viewportOffset.top + 100;

        //Header
        let stickyHeader = document.querySelector(".sticky_header");
        let stickyHeaderHeight = stickyHeader.offsetHeight - 2;

        //Navigation scroll
        let offset = cptNavigationPosition.offsetTop + 50;

        window.addEventListener("scroll", function () {
            let scroll = Math.round(window.scrollY);
            // let offset = top;

            //Active navigation if scroll
            if (scroll > offset) {
                navigationContainer.classList.add('fixed');
                navigationContainer.style.top = stickyHeaderHeight + 'px';

                //Only in residences page
                if (body.classList.contains('term-residences')) {
                    cptNavigationContainer.style.display = 'block';
                    cptNavigationContainer.style.opacity = '1';
                }
            } else {
                navigationContainer.classList.remove('fixed');
                navigationContainer.style.top = '0px';

                //Only in residences page
                if (body.classList.contains('term-residences')) {
                    cptNavigationContainer.style.display = 'none';
                    cptNavigationContainer.style.opacity = '0';
                }
            }
            const wellnessPage = document.querySelector(".page-template-template-wellness");
            //Active class to hash div
            if (!wellnessPage) {
                navigationLinks.forEach(link => {
                    let section = document.querySelector(link.getAttribute('href'));
                    let sectionOffset = section.offsetTop - 100;
                    let sectionHeight = section.offsetHeight;
                    let offsetNavigationLink = sectionOffset - navigationContainerHeight;

                    if (offsetNavigationLink <= scroll && offsetNavigationLink + sectionHeight > scroll) {
                        link.classList.add("active");
                    } else {
                        link.classList.remove("active");
                    }
                });
            }


        });
    }
    //Sticky navigation
}